import { render, staticRenderFns } from "./swgk.vue?vue&type=template&id=c0193e80&scoped=true&"
import script from "./swgk.vue?vue&type=script&lang=js&"
export * from "./swgk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0193e80",
  null
  
)

export default component.exports